export default __webpack_public_path__ + "static/media/No.1-4.d7a8824c.jpg";